interface HeadRowProp {
  total?: number | undefined;
}

export const BudgetAccountHeadRow: React.FC<HeadRowProp> = ({ total }: HeadRowProp) => {
  return (
    <tr className="border">
      {[
        "Acct #",
        "Description",
        "Unit",
        "Quantity",
        "Rate",
        "X",
        "Estimate",
        total ? total : "Total",
      ].map((boardcol, _boardidx) => {
        return (
          <th key={boardcol + ""} className={"bg-[#f2f2f2] text-black px-2 py-1 min-w-[100px]"}>
            {boardcol}
          </th>
        );
      })}
    </tr>
  );
};
